import { formatDate } from '@/utils/timeFormat';

/**
 * @description День в миллисекундах
 * @type {number}
 */
const dayMilliseconds = 24 * 60 * 60 * 1000;

/**
 * @description Неделя в миллисекундах.
 * @type {number}
 */
const weekMilliseconds = 24 * 60 * 60 * 1000 * 7;

const periodDay = 'day';
const periodMonth = 'month';
const periodWeek = 'week';
const periodYear = 'year';
const periodYesterday = 'yesterday';

const periodBy = (period) => ({
  [periodDay]: (date) => {
    const beforeDayDate = new Date();
    beforeDayDate.setTime(beforeDayDate.getTime() - dayMilliseconds);
    return [beforeDayDate, date];
  },
  [periodMonth]: (date) => {
    const currentMonth = date.getMonth();
    const beforeMonthDate = new Date();
    beforeMonthDate.setMonth(currentMonth - 1);
    return [beforeMonthDate, date];
  },
  [periodWeek]: (date) => {
    const beforeWeekDate = new Date();
    beforeWeekDate.setTime(beforeWeekDate.getTime() - weekMilliseconds);
    return [beforeWeekDate, date];
  },
  [periodYear]: (date) => {
    const currentYear = date.getFullYear();
    const beforeYearDate = new Date();
    beforeYearDate.setFullYear(currentYear - 1);
    return [beforeYearDate, date];
  },
  [periodYesterday]: () => {
    const beforeDayDate = new Date();
    beforeDayDate.setTime(beforeDayDate.getTime() - dayMilliseconds);
    return [beforeDayDate, beforeDayDate];
  },
}[period](new Date()));

/**
 * @description Примесь отчетов по продажам.
 * @type {Vue}
 */
export default {
  periodMonth,
  periodWeek,
  periodYear,
  periodYesterday,
  computed: {
    /**
     * @description Отображаемый заголовок выбранного периода.
     * @return {string}
     */
    periodTitle() {
      const [start, end] = this
        .period
        .map(this.getPreparedDate);
      if (!end) {
        return `${start}  —  ${start}`;
      }
      return `${start}  —  ${end}`;
    },
    /**
     * @description Название выбранного периода.
     * @type {string}
     */
    periodName() {
      if (this.period.length !== 2) {
        return '';
      }
      const [firstDate, secondDate] = this.period.slice().sort((a, b) => a - b);
      const [yesterdayFirstDate, yesterdaySecondDate] = periodBy(periodYesterday);
      if (
        formatDate(firstDate) === formatDate(yesterdayFirstDate)
        && formatDate(secondDate) === formatDate(yesterdaySecondDate)
      ) {
        return periodYesterday;
      }
      const now = new Date().toDateString();
      if (secondDate.toDateString() !== now) {
        return '';
      }
      const diffTime = secondDate.getTime() - firstDate.getTime();
      if (diffTime === dayMilliseconds) {
        return periodYesterday;
      }
      if (diffTime === weekMilliseconds) {
        return periodWeek;
      }
      if (secondDate.getDate() - firstDate.getDate() !== 0) {
        return '';
      }
      const diffYears = secondDate.getFullYear() - firstDate.getFullYear();
      const diffMonth = diffYears * 12 - firstDate.getMonth() + secondDate.getMonth();
      if (diffMonth === 1) {
        return periodMonth;
      }
      if (diffYears === 1) {
        return periodYear;
      }
      return '';
    },
  },
  data() {
    return {
      /**
       * @description Период формирования отчета.
       * @type {Date[]}
       */
      period: [],
    };
  },
  methods: {
    /**
     * Получить, готовые для отображения, даты.
     *
     * @param date
     * @return {string}
     */
    getPreparedDate(date) {
      const rawDate = date
        .toISOString()
        .split('T')[0]
        .split('-');
      return `${rawDate[2] ?? 'dd'}.${rawDate[1] ?? 'mm'}.${rawDate[0].slice(2) ?? 'YY'}`;
    },
    /**
     * @description Сохранить файл.
     * @param {any}    file Файл.
     * @param {string} name Название файла.
     */
    saveFile(file, name) {
      const obj = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = obj;
      link.target = '_blank';
      link.download = name;
      link.click();
      URL.revokeObjectURL(link.href);
      link.remove();
    },
    /**
     * @description Установить период по дню.
     * @returns {void}
     */
    setPeriodByDay() {
      this.period = periodBy(periodDay);
    },
    /**
     * @description Установить период по месяцу.
     * @returns {void}
     */
    setPeriodByMonth() {
      this.period = periodBy(periodMonth);
    },
    /**
     * @description Установить период по неделе.
     * @returns {void}
     */
    setPeriodByWeek() {
      this.period = periodBy(periodWeek);
    },
    /**
     * @description Установить период по году.
     * @returns {void}
     */
    setPeriodByYear() {
      this.period = periodBy(periodYear);
    },
    /**
     * @description Установить период по вчерашнему дню.
     * @returns {void}
     */
    setPeriodByYesterday() {
      this.period = periodBy(periodYesterday);
    },
    /**
     * @description Обработать изменение периода.
     * @param {Date[]} value
     * @returns {void}
     */
    onInputPeriod(value) {
      this.period = value.sort(
        (first, second) => Number(first.getTime() > second.getTime()),
      );
    },
    /**
     * @description Обработать закрытие диалога выборы даты.
     * @returns {void}
     */
    onCloseDatePickerDialog() {
      if (this.period.length === 1) {
        const [left] = this.period;
        this.onInputPeriod([left, left]);
      }
    },
  },
};
